export default class GlassColor {
  public id: string = ''
  public colorSetId!: string
  public name: string = ''
  public title: string = ''
  public image: string = ''
  public price: number = 0
  public selected: boolean = false
}
